import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import SportHeader from '@/features/sports/components/ui/SportHeader.vue';
import EventCard from '@/features/sports/components/global/EventCard.vue';
import CompetitionLogo from '@/features/sports/components/ui/CompetitionLogo.vue';
import { SingleStepContext } from '@/features/sports/helpers/config';
import { SportEventBucketsEdgeV2 } from '@/@types/graphql-types';
import { isMultiStepSport } from '@/features/sports/types/enums';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompetitionEventsItem',
  props: {
    competition: null,
    context: null
  },
  setup(__props: any) {

const props = __props as {
	competition: SportEventBucketsEdgeV2;
	context: SingleStepContext;
};



const fullPath = computed(() => {
	return props.competition.key.competition?.content.fullPath;
});

const name = computed(() => {
	return props.competition.key.competition?.content.name;
});

const hideHeader = computed(() => {
	return isMultiStepSport(props.context.sportType);
});

return { __sfc: true,props, fullPath, name, hideHeader, SportHeader, EventCard, CompetitionLogo }
}

})